_ = require 'underscore'
AttachmentHelpers = require './helpers'
AttachmentViewer = require 'views/internal/attachment-viewer'
Auth = require 'db/auth'
Browser = require 'lib/browser'
Confirm = require 'views/lib/confirm'
Dates = require 'lib/dates'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
KnownServices = require 'db/known-services'
pluginsChangedSignal = require 'views/internal/plugins/plugins-changed-signal'
pluginValidators = require 'lib/util/plugin-validators'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
PluginModelSerializer = require 'views/internal/plugins/plugin-model-serializer'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PluginView = require 'views/plugin/plugin-view'
PowerUpSuggester = require './power-up-suggester'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
PluginEnablePopOver = require 'views/plugin/plugin-enable-pop-over'
PluginSuggestionPopOver = require 'views/plugin/plugin-suggestion-pop-over'
sandboxParams = require 'data/plugin-iframe-sandbox'
Util = require 'lib/util'
View = require 'view'
l = require 'lib/localize'
t = require('views/internal/teacup-with-helpers')('plugin_attachment_thumbnail')
attachmentThumbnailTemplate = require 'views/templates/attachment_thumb'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
ClientConfig = require 'debug/client-config'
xtend = require 'xtend'

pluginThumbnailTemplate = t.renderable (data) ->
  {
    canRemove,
    canReply,
    created,
    createdBy,
    image,
    isHidden,
    initialize,
    modified,
    modifiedBy,
    title,
    url,
  } = data

  if isHidden
    return t.div

  if !image? || !image.url?
    image =
      url: ''

  linkOpts =
    href: url
    rel: 'noopener'
    target: url
    title: title

  titleOptions = ->
    if canReply
      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.js-reply', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'comment'

    if canRemove
      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.dark-hover.js-confirm-delete', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'remove'

  if image.logo
    t.a '.attachment-thumbnail-preview', _.clone(linkOpts), ->
      t.span '.attachment-thumbnail-preview-power-up-logo', ->
        t.img { class: 'attachment-thumbnail-preview-power-up-logo-image', src: "#{image.url}?color=999" }

  else
    t.a '.attachment-thumbnail-preview', xtend linkOpts,
      style: t.stylify
        'background-image': if image.url then t.urlify(image.url)
        'background-position-y': if image.y == 'top' then '0px'
        'background-position-x': if image.x == 'left' then '0px'
        'background-size': switch image.size
          when 'cover' then 'cover'
          when 'original' then 'inherit'
          else 'contain'

  t.p '.attachment-thumbnail-details', ->
    t.span '.attachment-thumbnail-name.js-attachment-name', ->
      t.text title

    t.span '.quiet.attachment-thumbnail-details-options', ->
      t.a '.attachment-thumbnail-details-title-action.dark-hover.js-attachment-action', _.clone(linkOpts), ->
        t.icon 'external-link'
        t.span '.attachment-thumbnail-details-options-item-text.js-direct-link'

    t.textarea '.attachment-thumbnail-details-title.js-attachment-thumbnail-details hide', maxlength: 256, ->
      t.text title

    t.span '.u-block.quiet.attachment-thumbnail-details-title-options', -> titleOptions()

    if created?
      t.span '.u-block.quiet', ->
        if createdBy?
          t.format 'created-by', { date: created, user: createdBy }
        else
          t.format 'created', { date: created }

      if modified?
        t.span '.u-block.quiet', ->
          if modifiedBy?
            t.format 'modified-by', { date: modified, user: modifiedBy }
          else
            t.format 'modified', { date: modified }

    if initialize? && pluginValidators.isValidUrlForIframe(initialize.url)
      if initialize.type == 'iframe'
        { url: initializeUrl } = initialize
        t.iframe '.plugin-iframe.plugin-thumbnail-initialize',
          sandbox: sandboxParams
          src: initializeUrl

  return

module.exports = class AttachmentThumbView extends PluginView
  className: 'attachment-thumbnail'

  events:
    'click .js-open-viewer': 'openViewer'
    'click .js-open-in-new-window': 'openLink'
    'click .js-direct-link': 'dontOpenViewer'

    'click .js-download': 'download'
    'click .js-make-cover': 'makeCover'
    'click .js-remove-cover': 'removeCover'
    'click .js-confirm-delete': 'confirmDelete'
    'click .js-reply': 'reply'
    'click .js-enable-power-up': 'enablePowerUp'
    'click .js-attachment-name': 'enableEditAttachmentName'
    'click .js-attachment-thumbnail-details': 'dontOpenViewer'
    'click .js-show-power-up-suggestions-info': 'showPowerUpSuggestionsInformation'

    'keydown .js-attachment-thumbnail-details': 'onEditAttachmentName'
    'blur .js-attachment-thumbnail-details': 'saveAttachmentName'

    'moveattachment': 'rearrangeAttachment'

  initialize: ->
    @isEditingAttachmentName = false
    @powerUpEnablementInProgress = false

    @listenTo Auth.me(), 'change:oneTimeMessagesDismissed', @frameDebounce @renderNormal
    @listenTo Auth.me(), 'change:messagesDismissed', @frameDebounce @renderNormal

  vigor: @VIGOR.NONE
  renderOnce: ->
    card = @model.getCard()
    board = card.getBoard()

    @subscribe pluginsChangedSignal(board, card).combine(
      card.snoop('idAttachmentCover').combine(
        @model.snoop('previews').combine(@model.snoop('name'))
      )
    ), =>
      @renderPluginThumbnail()
      .catch PluginRunner.Error.NotHandled, =>
        @renderNormal()
      .done()
    @

  renderPluginThumbnail: ->
    card = @model.getCard()
    board = card.getBoard()
    name = @model.get('name')

    PluginRunner.one
      command: 'attachment-thumbnail'
      card: card
      board: board
      options: PluginModelSerializer.attachment(@model)
    .then (data) =>
      if !_.isObject(data) || _.isArray(data) || _.isFunction(data)
        data = {}
      if data.title?
        @options?.onPluginThumbnail?(data.idPlugin)
      data.url = @model.get('url')
      if @options.isHidden
        @$el.addClass('hide')
      @$el.html pluginThumbnailTemplate xtend
        url: @model.get('url')
        , data,
        canRemove: @model.editable()
        canReply: @options.onReply? && board.canComment(Auth.me())
        created: if data.created then new Date(data.created)
        modified: if data.modified then new Date(data.modified)
        title: if name == data.url.slice(0, 256) then data.title else name
        isHidden: @options.isHidden
      Dates.update(@el)
      @initIFrames(board, card)
      @$('.js-attachment-thumbnail-details').autosize(append: false)
    .return()

  renderNormal: ->
    card = @model.getCard()
    board = card.getBoard()

    Promise.all([
      AttachmentHelpers.getAttachmentData(@model)

      Promise.try =>
        board.getAvailablePlugins()
          .filter (plugin) =>
            plugin.id == PowerUpSuggester.getPowerUpIdFromClaimedPowerUpDomains(@model.get('url'))
          .map (plugin) =>
            pluginIO = PluginIOCache.get(plugin)
            Promise.props
              id: plugin.id
              name: pluginIO.getName()
              description: pluginIO.getDescription()
              iconUrl: pluginIO.getIconUrl()
          .get(0)
    ])
    .spread (data, suggestedPlugin) =>
      data.canUseViewer =
        @model.getServiceKey() != 'dropbox' &&
        AttachmentHelpers.isViewerable(data.ext) &&
        !Browser.isTouch()
      data.canReply = @model.getCard().getBoard()?.canComment(Auth.me())

      preview = @model.smallestPreviewBiggerThan(110, 80) ? @model.biggestPreview()
      if Browser.isHighDPI()
        hiDpipreview = @model.smallestPreviewBiggerThan(220, 160)
        preview = hiDpipreview ? preview

      if preview?
        showCardCovers = card.getBoard()?.get('prefs')?.cardCovers
        data.isCover = showCardCovers && card.get('idAttachmentCover') == @model.id
        data.imgSrc = preview.url

      data.isUpload = @model.get('isUpload')
      data.editable = @model.editable()

      @suggestedPlugin = suggestedPlugin
      if @suggestedPlugin?.id
        if !card.getBoard().isPluginEnabled(@suggestedPlugin.id)
          if Auth.me().shouldShowPowerUpSuggestionFor(@suggestedPlugin.id)
            trackUe('card-detail', 'views', 'Power-Up enable suggestion', '', '', '', @suggestedPlugin.id)
            data.plugin = @suggestedPlugin
        else
          data.pluginEnablementInProgress = @powerUpEnablementInProgress? && @powerUpEnablementInProgress

      if card.getBoard().getOrganization()?.isFeatureEnabled('plugins') || !ClientConfig.get('dontUpsell')
        data.upsellEnabled = true

      if @options.isHidden
        @$el.addClass('hide')
      @$el.html attachmentThumbnailTemplate(xtend(data, { isHidden: @options.isHidden }))

      @renderCoverState()

      Dates.update(@el)

      if data.isKnownService
        $thumbnail = @$('.js-attachment-thumbnail-details')
        KnownServices.thumbnailHtml data.url, data, (err, html) ->
          if !err? && html?
            $thumbnail.html(html)
            Dates.update($thumbnail)

      @$('.js-attachment-thumbnail-details').autosize(append: false)
    .done()

    @

  openViewer: (e) ->
    if e.metaKey || e.ctrlKey || @isEditingAttachmentName
      return

    Util.stop(e)
    if !AttachmentViewer.isActive()
      AttachmentViewer.show
        model: @model.getCard()
        attachmentModel: @model
      track("Attachment", "Open Attachment Viewer", @model.getType())
    return

  dontOpenViewer: (e) ->
    e.stopPropagation()

  renderCoverState: ->
    allowsCardCovers = @model.getCard()?.getBoard()?.getPref('cardCovers')
    $make = @$('.js-make-cover').addClass('hide')
    $remove = @$('.js-remove-cover').addClass('hide')

    if @model.get('previews')?.length > 0 && allowsCardCovers
      isCover = @model.getCard()?.get('idAttachmentCover') == @model.id

      $make.toggleClass('hide', isCover)
      $remove.toggleClass('hide', !isCover)

    return

  download: (e) ->
    Util.stopPropagation(e)
    track("Attachment", "Attachment Thumbnail", "Download")
    return

  makeCover: (e) ->
    Util.stop(e)
    PopOver.hide()
    @model.getCard().makeCover(@model)
    track("Attachment", "Attachment Thumbnail", "Make Cover")
    return

  removeCover: (e) ->
    Util.stop(e)
    PopOver.hide()
    @model.getCard().removeCover(null)
    track("Attachment", "Attachment Thumbnail", "Remove Cover")
    return

  confirmDelete: (e) ->
    Util.stop(e)

    babbleKey = if @model.get('isUpload')
      'delete attachment'
    else
      'remove attachment'

    Confirm.toggle babbleKey,
      elem: @$('.js-confirm-delete')
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.destroy()
        track("Attachment", "Delete Attachment", @model.getType())

    track("Attachment", "Attachment Thumbnail", "Confirm Delete")
    return

  reply: (e) ->
    Util.stop(e)
    @options.onReply()

  enablePowerUp: (e) ->
    Util.stop(e)

    board = @model.getCard().getBoard()
    plugin = @suggestedPlugin

    if !board.canEnableAdditionalPowerUps()
      PopOver.toggle
        elem: @$(e.target)
        view: new PluginEnablePopOver({ model: board, plugin })
        autoPosition: true

      return

    if board.isPluginEnabled(plugin.id)
      @renderNormal()
      return

    @powerUpEnablementInProgress = true
    @renderNormal()
    board.enablePlugin(plugin.id)
      .then =>
        @powerUpEnablementInProgress = false
        @renderNormal()
      .done()

    trackUe('card-detail', 'enables', 'Power-Up', '', '', 'enable button', plugin.id)
    return

  enableEditAttachmentName: (e) ->
    if not @model.getCard().editable()
      return

    Util.stopPropagation(e)

    @isEditingAttachmentName = true

    @$('.js-attachment-name').addClass('hide')
    @$('.js-attachment-action').addClass('hide')
    @$('.js-attachment-thumbnail-details').removeClass('hide')
                                          .trigger('autosize.resize')
                                          .focus()
                                          .select()

  showPowerUpSuggestionsInformation: (e) ->
    trackUe('card-detail', 'views', 'Power-Up enable suggestion info screen', '', '', 'by clicking the info icon', @suggestedPlugin.id)

    Util.stopPropagation(e)

    card = @model.getCard()
    board = card.getBoard()

    options = {
      model: @suggestedPlugin,
      board
    }

    PopOver.toggle
      elem: @$(e.target)
      view: new PluginSuggestionPopOver(options),
      autoPosition: true

    return

  onEditAttachmentName: (e) ->
    $input = @$(e.currentTarget).trigger('autosize.resize')

    if Keyboard.getKey(e) == Keys.Enter or Keyboard.getKey(e) == Keys.Escape
      Util.stop(e) # prevents new lines (enter) and closing of card (escape)

      $input.blur()

  saveAttachmentName: (e) ->
    @isEditingAttachmentName = false

    $input = @$(e.currentTarget)
    $a11yName = @$('.js-attachment-name')

    newName = $input.val().replace(/\s+/g, ' ').trim()
    oldName = @model.get('name')

    if newName.length > 256
      newName = newName.substring(0, 256)
      $input.text(newName)

    if newName != oldName and newName.length > 0
      $a11yName.text(newName)
      @model.update 'name', newName
    else
      $input.val(oldName)
      $a11yName.text(oldName)

    @$('.js-attachment-name').removeClass('hide')
    @$('.js-attachment-action').removeClass('hide')
    @$('.js-attachment-thumbnail-details').addClass('hide')

  rearrangeAttachment: (e, ui) ->
    card = @model.getCard()
    if card?
      attachments = ui.item.parent().children()
      index = attachments.index(ui.item)

      @model.update('pos', card.calcAttachmentPos(index, @model))
      @model.collection.sort({ silent: true })

      if @$('.plugin-iframe').length
        @renderPluginThumbnail()

      track("Attachment", "Reorder Attachment")

  openLink: ->
    url = @model.get('url')
    window.open(url, url)



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/attachment-thumb-view.coffee